import React, {useEffect} from "react"

var inline = () => {
    var inlineSVG = require('inline-svg');
    inlineSVG.init({
      svgSelector: 'img.svg', // the class attached to all images that should be inlined
      initClass: 'js-inlinesvg', // class added to <html>
    }, function () {
      console.log('All SVGs inlined');
    });
}

const Questionario = ({ questionario, escolheQuestao }) => {

  useEffect( ()=>{
    console.log(questionario.id);
    inline()
 }, [] );


 return (
      <div key={questionario.id} className="questionario" onClick={() => escolheQuestao(questionario)} style={{cursor:"pointer", marginBottom:"3%"}}>
            
        <img className="svg img" src={questionario.Icon.publicURL}></img>
        <div className="questionarioText">{questionario.Name}</div>
      </div>
   )

      
}

export default Questionario
